// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2P4O9","modalForm":"UpgradeEpcsModal_modalForm__75K_4","modalFooter":"UpgradeEpcsModal_modalFooter__1ZBm9"};